import React, { useState } from "react"
import { Box } from "@mui/material"
import RecipeCard from "./RecipeCard"

const DraggableRecipeCard = ({ recipe, displayProdDates, isDone, onRemove, onDragStart, onDragEnd }) => {
  const [isDragging, setIsDragging] = useState(false)

  const handleDragStart = (e) => {
    if (e.target.closest && e.target.closest("[data-no-drag]")) {
      e.preventDefault()
      return
    }
    e.dataTransfer.effectAllowed = "copy"
    e.dataTransfer.setData("text/plain", recipe.recipeId)
    setIsDragging(true)
    onDragStart({ recipe, sourceSlotId: null, displayProdDates })
  }

  const handleDragEnd = () => {
    setIsDragging(false)
    onDragEnd()
  }

  return (
    <Box
      draggable
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      sx={{ opacity: isDragging ? 0.4 : 1, cursor: "grab", outline: "none" }}
    >
      <RecipeCard recipe={recipe} displayProdDates={displayProdDates} isDone={isDone} onRemove={onRemove} />
    </Box>
  )
}

export default DraggableRecipeCard
